/// <reference types="@angular/localize" />

import { enableProdMode, isDevMode, DOCUMENT, LOCALE_ID } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideServiceWorker } from '@angular/service-worker';
import { Router, provideRouter, withHashLocation } from '@angular/router';
import { enableElfProdMode } from '@ngneat/elf';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { APP_CONFIG, AppConfig } from './app/configs/app.config';
import { AuthHttpInterceptor } from './app/shared/interceptors/auth-http.interceptor';
import { AuthService } from './app/features/auth/shared/services/auth.service';
import { AuthRepository } from './app/features/auth/store/auth.repository';
import { APP_ROUTES } from './app/app.routes';
registerLocaleData(localeEs);
if (environment.production) {
  enableProdMode();
  enableElfProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    provideHttpClient(
      withInterceptorsFromDi()
    ),

    provideServiceWorker('custom-sw.js', {
      enabled: true,
      registrationStrategy: 'registerImmediately',
    }),

    provideRouter(APP_ROUTES, withHashLocation()),

    { provide: APP_CONFIG, useValue: AppConfig },
    { provide: Document, useExisting: DOCUMENT },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCaptchaV3.siteKey },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
      deps: [Router, AuthService, AuthRepository, DOCUMENT],
    },
  ],
}).catch(err => console.table(err));
